module.exports = __webpack_public_path__ + "fonts/opensans-extrabold.bbda8765.ttf";